// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TickIcon_wrapper__95AOy","svg":"TickIcon_svg__WBFC5"};